import React from "react";
// import { FormItemProps } from "../../../types";

export const FormItem = ({ className, children }: any) => (
  <div className={className ? `${className} form-item` : "form-item"}>
    {children}
  </div>
);
